// extracted by mini-css-extract-plugin
export default {"more":"GroupDescription_more__jtXK8","description":"GroupDescription_description__RouQa","root":"GroupDescription_root__ds0DK"};